import { GqlProducts } from 'types/graphql';
import { GenericPriceOption } from '../generic-product';

// eslint-disable-next-line @typescript-eslint/naming-convention
export function transformOptions({ Options, Prices }: Pick<GqlProducts, 'Options' | 'Prices'>): GenericPriceOption[] {
  if (!Options || !Prices) {
    return [];
  }

  if (Options.length !== Prices.length) {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    throw new Error(`Invalid product: (${JSON.stringify({ Options, Prices })}) `);
  }

  return Options.map((weight, idx) => {
    const price = Prices[idx];

    if (typeof price !== 'number' || typeof weight !== 'string') {
      throw new Error(`Invalid product: (${JSON.stringify({ price, weight })}) `);
    }

    return { price, weight };
  });
}
